module.exports = __webpack_public_path__ + "static/media/pencil.1ff4839e.svg";